var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSampleAnalyzedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 81,
    viewBox: "0 0 86 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12668_2141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.59961,
    y: 2.59961,
    width: 72,
    height: 67,
    rx: 14,
    fill: "url(#paint0_linear_12668_2141)",
    fillOpacity: 0.24,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7867 21.5325L54.4533 26.8658C54.8976 27.0866 55.2715 27.4269 55.533 27.8486C55.7944 28.2702 55.9331 28.7564 55.9333 29.2525V41.9592C55.9331 42.4553 55.7944 42.9415 55.533 43.3631C55.2715 43.7847 54.8976 44.1251 54.4533 44.3458L43.7867 49.6792C43.4162 49.8645 43.0076 49.9611 42.5933 49.9611C42.1791 49.9611 41.7705 49.8645 41.4 49.6792L30.7333 44.3458C30.2895 44.1222 29.917 43.779 29.6579 43.3549C29.3987 42.9308 29.2632 42.4428 29.2667 41.9458V29.2525C29.2669 28.7564 29.4056 28.2702 29.667 27.8486C29.9285 27.4269 30.3024 27.0866 30.7467 26.8658L41.4133 21.5325C41.7821 21.3493 42.1882 21.2539 42.6 21.2539C43.0118 21.2539 43.4179 21.3493 43.7867 21.5325V21.5325Z",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6934 27.8125L42.6 34.2658L55.5067 27.8125",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5996 49.9466V34.2666",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9326 24.2666L49.2659 30.9333",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12668_2141",
    x: -0.00039053,
    y: -0.00039053,
    width: 85.2,
    height: 80.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.945098 0 0 0 0 0.760784 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12668_2141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12668_2141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12668_2141",
    x1: -2.90039,
    y1: -4.40039,
    x2: 48.0996,
    y2: 73.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5F200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9C700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleAnalyzedIcon);
export default __webpack_public_path__ + "static/media/sample_analyzed_icon.2f844a2884e5e8f4c79e33e0ab3f1ce6.svg";
export { ForwardRef as ReactComponent };